import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, ViewChild } from '@angular/core';
import { formatDate } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription, timer } from 'rxjs';
import { SmartAppUtilities } from 'src/app/models/common/getjsonfrom-controls-service-model';
import { ResOrderDetails } from 'src/app/models/Restaurant/ResOrderDetails.model';
import { ResOrders } from 'src/app/models/Restaurant/ResOrders.model';
import { ResponseModel } from 'src/app/models/SharedModels/response.model';
import { TaxGroupInModel } from 'src/app/models/tax-group/tax-rate-in-model';
import { findArrayMax, sortArray } from 'src/app/services/common-methods/common-methods-exports';
import { LoaderService } from 'src/app/services/loader/LoaderService';
import { RestaurantService } from 'src/app/services/restaurant/restaurant.service';
import { WebsocketService } from 'src/app/services/restaurant/websocket.service';
import { BusinessServices } from 'src/app/services/singleton/business-services';
import { ApplicationCodes, CommonConstant } from 'src/app/shared/constent/applicationcodes';
import { DateFormatterPipe } from 'src/app/shared/custom-pipes/date-formatter.pipe/date-formatter.pipe';
import { TranslatePipe } from 'src/app/shared/custom-pipes/translate-pipe/translate.pipe';
import { SanitizeValueFormatter } from 'src/app/value-formatters/sanitize-value-formatter';
import { Globals } from 'src/environments/Globals';
declare var $: any;
declare var bootstrap: any;

@Component({
  selector: 'app-pos-desktop',
  templateUrl: './pos-desktop.component.html',
  styleUrls: ['./pos-desktop.component.css']
})

export class PosDesktopComponent implements AfterViewInit, OnDestroy {
  @ViewChild('customerNameInput') customerNameInput!: ElementRef;
  @ViewChild('customerPhoneInput') customerPhoneInput!: ElementRef;

  domainURL: string = '';
  tableList: any[] = [];
  godownData: any[];
  paymentMethod: any[] = [];
  SalesAgentData: any[] = [];
  filteredFamilyDetails: any[] = [];
  groupedProducts: { [key: string]: any[] } = {};
  selectedUOMs: any[] = [];
  applicationCodes = new ApplicationCodes();

  printTime: any = "";
  printerName: any = "";
  CompanyLogo: any = "";
  CompanyCode: any = "";
  companyMobile: any = "";
  companyFax: any = "";
  vatNumber: string = "";
  CompanyAddress: string = "";
  companyname: string = "";
  ntn: string = "";
  totalSum: number = 0;
  globalTaxes: TaxGroupInModel[]; // will use for autcomplete search
  taxGroups: TaxGroupInModel[]; // will get all taxes

  billDetails = {
    customerName: '',
    items: [],
    selectedTable: '',
    paymentMethod: 'cash'
  };

  subtotal = 35.00;
  discount = 5.50;
  tax = 3.50;

  // categories = ['All Menu', 'Coffee', 'Tea', 'Juice', 'Rice', 'Pasta'];
  familyCategories: any[] = [];
  selectedCategory: any = 0;
  orderType: string = '';
  searchFilter: string = '';
  ascDesc: number = 2;
  showMainContent: Boolean = false;

  selectedType: string = 'DineIn';
  holdInvoice: string = '';
  isDineIn: boolean = true;
  isTakeAway: boolean = false;
  isDelivery: boolean = false;
  isUpdate: boolean = false;
  isGenerateBill: boolean = false;
  isBillList: boolean = false;
  isPaidOrderList: boolean = false;
  model: ResOrders = new ResOrders();
  printModel: ResOrders = new ResOrders();
  pendingOrdersList = new Array<ResOrders>();
  printPenginOrderList = new Array<ResOrders>();
  paidOrderList = new Array<ResOrders>();
  timeName: string = "";
  timeValue: number = -1440;

  goDowmCode: any = "";

  get total(): number {
    return this.subtotal - this.discount + this.tax;
  }

  private modalInstance: any;

  subscription: Subscription;
  intervalSubscription: Subscription;

  jsonObject: any[] = [];
  smartUtilities = new SmartAppUtilities(this.toastrService);
  commonconstant = new CommonConstant();

  notifications: Array<Notification> = new Array<Notification>();
  totalUnreadNotifications: number = 0;

  constructor(private businessService: BusinessServices, private svf: SanitizeValueFormatter, private loaderService: LoaderService, private socketService: WebsocketService,
    private toastrService: ToastrService, private translate: TranslatePipe, private restaurantService: RestaurantService, private globals: Globals, private cdr: ChangeDetectorRef
    , private dateFormat: DateFormatterPipe
  ) {
    this.domainURL = window.location.origin;
  }

  ngOnInit() {
    this.socketService.connect('wss://devsocket.nuktaerp.com/ws');

    $(document).click(function () {
      $("#notfidrop").hide();
    });

    $(".bellicon").click(function (e) {
      e.stopPropagation();
      $("#notfidrop").show();
    });

    this.businessService.commonService.Get(this.applicationCodes.GodownTableName+ ',' + this.applicationCodes.ResTables + ',' + this.applicationCodes.PaymentMethods + ',' + this.applicationCodes.SalesAgentNamesSearchTable).subscribe((data: any) => {
      this.godownData = data.filter(x => x.TblName == this.applicationCodes.GodownTableName);
      this.tableList = data.filter(x => x.TblName == this.applicationCodes.ResTables);
      this.paymentMethod = data.filter(x => x.TblName == this.applicationCodes.PaymentMethods);
      this.SalesAgentData = data.filter(x => x.TblName == this.applicationCodes.SalesAgentNamesSearchTable);
    });

    this.businessService.taxGroupRepository.GetAllTaxes().subscribe((data: ResponseModel) => {
      if (data._statusCode == 200 && data._obj) {
        this.taxGroups = data._obj;
        this.globalTaxes = data._obj.filter(x => x.TaxLevel == 2);

        var cashMethod = this.globalTaxes.find(x => x.Tax1Name == "Cash");
        if(cashMethod){
          this.model.GlobalTaxCode = cashMethod.Tax1Code;
          this.model.GlobalTaxRate = cashMethod.Tax1Value;
          this.model.GlobalTaxGroupName = cashMethod.Tax1Name;
        }
      }
    });

    this.GetProductFamilyList();


    if (this.globals.getDataFromLocalStorage(this.commonconstant.CompanyName) != null && this.globals.getDataFromLocalStorage(this.commonconstant.CompanyName) != "") {
      this.companyname = this.globals.getDataFromLocalStorage(this.commonconstant.CompanyName);
    }

    if (this.globals.getDataFromLocalStorage(this.commonconstant.CompanyVatNumber) != null && this.globals.getDataFromLocalStorage(this.commonconstant.CompanyVatNumber) != "") {
      this.ntn = this.globals.getDataFromLocalStorage(this.commonconstant.CompanyVatNumber);
    }

    if (this.globals.getDataFromLocalStorage(this.commonconstant.PrinterName) != null && this.globals.getDataFromLocalStorage(this.commonconstant.PrinterName) != "") {
      this.printerName = this.globals.getDataFromLocalStorage(this.commonconstant.PrinterName);
    }

    if (this.globals.getDataFromLocalStorage(this.commonconstant.CompanyAddress) != null && this.globals.getDataFromLocalStorage(this.commonconstant.CompanyAddress) != "") {
      this.CompanyAddress = this.globals.getDataFromLocalStorage(this.commonconstant.CompanyAddress);
    }

    if (this.globals.getDataFromLocalStorage(this.commonconstant.CompanyLogo) != null && this.globals.getDataFromLocalStorage(this.commonconstant.CompanyLogo) != ",") {
      this.CompanyLogo = this.globals.getDataFromLocalStorage(this.commonconstant.CompanyLogo);
    }

    if (this.globals.getDataFromLocalStorage(this.commonconstant.MobileNo) != null && this.globals.getDataFromLocalStorage(this.commonconstant.MobileNo) != ",") {
      this.companyMobile = this.globals.getDataFromLocalStorage(this.commonconstant.MobileNo);
    }

    if (this.globals.getDataFromLocalStorage(this.commonconstant.ContactNumber) != null && this.globals.getDataFromLocalStorage(this.commonconstant.ContactNumber) != ",") {
      this.companyFax = this.globals.getDataFromLocalStorage(this.commonconstant.ContactNumber);
    }

    if (this.globals.getDataFromLocalStorage(this.commonconstant.CompanyLogo) != null && this.globals.getDataFromLocalStorage(this.commonconstant.CompanyLogo) != ",") {
      this.CompanyLogo = this.globals.getDataFromLocalStorage(this.commonconstant.CompanyLogo);
    }

    if (this.globals.getDataFromLocalStorage(this.commonconstant.LoggedInCompanyID)) {
      this.CompanyCode = this.globals.getDataFromLocalStorage(this.commonconstant.LoggedInCompanyID);
    }

    setInterval(() => {
      this.orderCountDown();
    }, 1000);
    this.model.OrderType = 1;
    this.model.Status = 1;
    this.model.DeliveryCharges = 40;

  }

  ngAfterViewInit() {
    this.updateNotificationsListFromStorage()
    this.bindPrintOrdersListings(this.goDowmCode, this.timeValue);

  }

  bindPrintOrdersListings(goDownCode: string, timeValue: number) {
    let date = new Date()
    date = this.dateFormat.transform(new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1, 0, 0, 0, 0), 'yyyy-MM-dd hh:mm:ss');
    let latestDate = this.dateFormat.transform(new Date(), 'yyyy-MM-dd HH:mm:ss');

    this.restaurantService.ordersRepository.GetAllForKitchen(goDownCode, date, date, timeValue, latestDate, this.ascDesc, this.orderType).subscribe(data => {

      if (data._statusCode === 200 && data._obj && data._obj.length > 0) {
        this.loaderService.setIgnoreLoader(false);
        let pendingOrders = data._obj.filter(x => x.Status == 1)
        if (pendingOrders && pendingOrders.length > 0)
          sessionStorage.setItem(this.commonconstant.Last_Pending_Order_Time_kitchen, findArrayMax(pendingOrders, 'OrderRecordTimeStamp').OrderRecordTimeStamp)
        else {
          sessionStorage.setItem(this.commonconstant.Last_Pending_Order_Time_kitchen, date.toString())
        }


        let progressOrders = data._obj.filter(x => x.Status == 2)
        if (progressOrders && progressOrders.length > 0) {
          sessionStorage.setItem(this.commonconstant.Last_Order_Time_Kitchen, findArrayMax(progressOrders, 'OrderRecordTimeStamp').OrderRecordTimeStamp)
        }
        else {
          sessionStorage.setItem(this.commonconstant.Last_Order_Time_Kitchen, date.toString())
        }

        this.printPenginOrderList = pendingOrders;
      }
      else {
        this.printPenginOrderList = [];
      }
    });

    if (this.intervalSubscription)
      this.intervalSubscription.unsubscribe();

    this.intervalSubscription = timer(10000, 10000).subscribe(x => {
      this.loaderService.setIgnoreLoader(true);
      this.subscription = this.restaurantService.ordersRepository.GetAllForKitchen(goDownCode, this.getLastInProgressOrderTime(), this.getLastPendingOrderTime(), timeValue, latestDate, this.ascDesc, this.orderType)
        .subscribe(data => {
          if (data._statusCode === 200 && data._obj && data._obj.length > 0) {
            this.loaderService.setIgnoreLoader(false);
            let pendingOrders = data._obj.filter(x => x.Status == 1);
            if (pendingOrders && pendingOrders.length > 0) {

              sessionStorage.setItem(this.commonconstant.Last_Pending_Order_Time_kitchen, findArrayMax(pendingOrders, 'OrderRecordTimeStamp').OrderRecordTimeStamp)
              pendingOrders.forEach(element => {

                let orderIndex = this.printPenginOrderList.findIndex(x => x.OrderCode == element.OrderCode)
                if (orderIndex != -1) {
                  this.printPenginOrderList[orderIndex] = element
                  this.showNotification(element, 'UPDATE')
                }
                else {
                  this.printPenginOrderList.push(element)
                  this.showNotification(element)

                  // if (this.CompanyCode == '1000000001') {
                  setTimeout(() => {

                    this.printModel = element;
                    this.printModel.CompanyName = this.companyname;
                    this.printModel.NTN = this.ntn;
                    this.printModel.CompanyAddress = this.CompanyAddress;
                    this.printModel.PhoneNumber = this.companyMobile;
                    this.printModel.FaxNumber = this.companyFax;
                    const printerSet = new Set<string>();

                    element.ResOrderDetailList.forEach(element => {

                      if (element.PrinterName) {
                        const printers = element.PrinterName.split(',')
                          .map(p => p.trim())
                          .filter(p => p); // remove empty strings

                        printers.forEach(p => printerSet.add(p)); // avoid duplicates
                      }
                    });

                    printerSet.forEach(element => {
                      if (element) {
                        this.printModel.PrinterName = element;
                        this.socketService.sendMessage(JSON.stringify(this.printModel));
                      }
                    });
                  }, 500); // delay is safe now
                  // }
                }
              });
            }
          }
          this.loaderService.setIgnoreLoader(false);
        });
    });
  }

  getLastInProgressOrderTime(): any {

    let orderTime: any = sessionStorage.getItem(this.commonconstant.Last_Order_Time_Kitchen)

    if (!orderTime) {
      orderTime = new Date();
      orderTime = this.dateFormat.transform(new Date(orderTime.getFullYear(), orderTime.getMonth(), orderTime.getDate(), 0, 0, 0, 0), 'yyyy-MM-dd hh:mm:ss');
    }
    return orderTime;
  }

  getLastPendingOrderTime(): any {
    let orderTime: any = sessionStorage.getItem(this.commonconstant.Last_Pending_Order_Time_kitchen)
    if (!orderTime) {
      orderTime = new Date();
      orderTime = this.dateFormat.transform(new Date(orderTime.getFullYear(), orderTime.getMonth(), orderTime.getDate(), 0, 0, 0, 0), 'yyyy-MM-dd hh:mm:ss');
    }
    return orderTime;
  }

  fetchOrderType(type: string) {
    if (type) {
      this.selectedType = type == '0' ? 'All' : (type == '1' ? 'DineIn' : (type == '2' ? 'Take Away' : 'Delivery'));
      this.orderType = type;

      if (this.isBillList)
        this.bindOrdersListings();

      if (this.isPaidOrderList)
        this.getAllPaidOrders();
    }
    else
      this.selectedType = '';
  }

  getAllPaidOrders(goDownCode: string = "") {
    if (this.orderType) {
      this.selectedType = this.orderType == '0' ? 'All' : (this.orderType == '1' ? 'DineIn' : (this.orderType == '2' ? 'Take Away' : 'Delivery'));
    }
    else {
      this.selectedType = '';
    }

    this.orderType = this.orderType == '0' ? '' : this.orderType;
    this.isBillList = false;

    this.restaurantService.ordersRepository.getAllPaidOrders(goDownCode, this.ascDesc, this.orderType).subscribe(data => {
      this.loaderService.setIgnoreLoader(false);

      if (data._statusCode === 200 && data._obj && data._obj.length > 0) {
        this.paidOrderList = data._obj;
        this.isPaidOrderList = true;
      }
      else {

        this.paidOrderList = [];
        this.isPaidOrderList = true;
      }
    });


  }

  bindOrdersListings(goDownCode: string = "") {
    if (goDownCode) {
      this.orderType = goDownCode;
      goDownCode = '';
    }

    if (this.orderType) {
      this.selectedType = this.orderType == '0' ? 'All' : (this.orderType == '1' ? 'DineIn' : (this.orderType == '2' ? 'Take Away' : 'Delivery'));
    }
    else {
      this.selectedType = '';
    }

    this.orderType = this.orderType == '0' ? '' : this.orderType;
    this.isPaidOrderList = false;

    this.restaurantService.ordersRepository.GetAllForPOSKitchen(goDownCode, this.ascDesc, this.orderType).subscribe(data => {
      this.loaderService.setIgnoreLoader(false);
      if (data._statusCode === 200 && data._obj && data._obj.length > 0) {

        this.pendingOrdersList = data._obj;
        this.isBillList = true;
      }
      else {
        this.pendingOrdersList = [];
        this.isBillList = true;
      }
    });


  }


  bindHoldOrdersListings(goDownCode: string = "") {
    if (goDownCode) {
      this.orderType = goDownCode;
      goDownCode = '';
    }

    if (this.orderType) {
      this.selectedType = this.orderType == '0' ? 'All' : (this.orderType == '1' ? 'DineIn' : (this.orderType == '2' ? 'Take Away' : 'Delivery'));
    }
    else {
      this.selectedType = '';
    }

    this.orderType = this.orderType == '0' ? '' : this.orderType;
    this.isPaidOrderList = false;

    this.restaurantService.ordersRepository.GetAllHoldOrders(goDownCode, this.ascDesc, this.orderType).subscribe(data => {
      this.loaderService.setIgnoreLoader(false);

      if (data._statusCode === 200 && data._obj && data._obj.length > 0) {

        this.pendingOrdersList = data._obj;
        this.isBillList = true;
      }
      else {
        this.pendingOrdersList = [];
        this.isBillList = true;
      }
    });


  }

  GetProductFamilyList() {

    this.businessService.productCardRepository.GetProductFamily(this.searchFilter).subscribe(
      (data: any) => {
        if (data && data._statusCode === 200 && data._obj) {
          this.familyCategories = data._obj;
          this.familyCategories.forEach(element => {
            if (element.FamilyGroupDetail != null) {
              this.selectedCategory = element.Name;
              // this.filteredFamilyDetails.push(...element.FamilyGroupDetail);
              this.processProducts(element.FamilyGroupDetail);
            }
          });

        }
      });

  }

  processProducts(data: any) {
    const tempMap: { [key: string]: any[] } = {};

    // Group by ProductCode
    for (const product of data) {
      if (!tempMap[product.ProductCode]) {
        tempMap[product.ProductCode] = [];
      }
      tempMap[product.ProductCode].push(product);
    }

    this.filteredFamilyDetails = [];

    // Build final lists
    for (const code in tempMap) {
      const group = tempMap[code];
      this.filteredFamilyDetails.push(group[0]); // first one for the card
      this.groupedProducts[code] = group; // remaining for popup
      // this.groupedProducts[code] = group.slice(1); // remaining for popup
    }
  }

  showMore(productCode: string) {

    const moreUOMs = this.groupedProducts[productCode];
    // Trigger your modal/popup here with `moreUOMs`
  }

  GetProductFamilyDetailList(searchFilter: string) {


    this.businessService.productCardRepository.GetProductFamilyDetail(searchFilter).subscribe(
      (data: any) => {
        if (data && data._statusCode === 200 && data._obj) {

          const index = this.familyCategories.findIndex(item => item.ProductGroupCode === searchFilter);

          // Update if found
          if (index !== -1) {
            this.familyCategories[index].FamilyGroupDetail = data._obj;
          }

          // this.filteredFamilyDetails = data._obj;
          this.processProducts(data._obj);
        }
      });

  }

  selectPayment(method: any) {
    this.selectedPayment = method;
    this.model.PaymentMode = method == 'cash' ? '1' : (method == 'card' ? '2' : '3');
    if (this.paymentMethod == null) {
      this.model.PaymentMode = '1'
    }
  }

  increaseQty(item: any, isCalculate: boolean = false) {
    if (item.Quantity >= 0) {
      item.Quantity = item.Quantity + 1;
      if (isCalculate)
        this.refreshUICalculations();
    }
  }

  decreaseQty(item: any, isCalculate: boolean = false) {
    if (item.Quantity >= 1) {
      item.Quantity = item.Quantity - 1;
      if (isCalculate)
        this.refreshUICalculations();
    }
  }

  addToCart(item: any) {

    let isContinue = true;
    if (this.jsonObject != null || this.jsonObject.length > 0) {
      var alreadyExits = this.jsonObject.find(x => x.ProductCode == item.ProductCode && x.ProductBarCode == item.ProductBarCode);
      if (alreadyExits) {
        this.toastrService.error(this.translate.transform('3972'));
        isContinue = false;
      }
    }

    if (this.isBillList || this.isPaidOrderList) {
      this.isBillList = false;
      this.isPaidOrderList = false;
    }
    if (isContinue) {
      var data = [];
      var newRecord = new ResOrderDetails();
      newRecord.SerialNumber = this.jsonObject.length + 1;
      newRecord.ProductName = item.Name + "" + item.UOMName;
      newRecord.ProductCode = item.ProductCode;
      newRecord.ProductBarCode = item.ProductBarCode;
      newRecord.Quantity = item.Quantity == undefined ? 1 : item.Quantity;
      newRecord.UnitType = item.UnitType;
      newRecord.UOMName = item.UOMName;
      newRecord.UnitCode = item.UOMCode;
      newRecord.ProductType = item.ProductType;
      newRecord.Action = 'Save';
      newRecord.Price = item.SalesPrice;
      newRecord.DiscountAmount = item.DiscountAmoount;
      newRecord.GrandAmount = (item.SalesPrice * item.Quantity) - newRecord.DiscountAmount;
      newRecord.GrandAmount = 0;
      if (this.isUpdate)
        newRecord.IsUpdated = true;

      data.push(newRecord);
      if (this.jsonObject == undefined)
        this.jsonObject = [];

      this.jsonObject.push(newRecord);
      this.refreshUICalculations();
    }

    this.selectedUOMs = [];

    // Close modal
    if (this.modalInstance) {
      this.modalInstance.hide();
    }
  }

  ProductDiscount(order: any){
     if(order.DiscountAmount > order.GrandAmount){
      this.toastrService.error("Discount amount should not be greater then sale price");
     }
     else{
        order.GrandAmount = Number(order.GrandAmount - order.DiscountAmount);
        this.refreshUICalculations();
     }
  }

  removeItem(itemToRemove: any) {
    this.jsonObject = this.jsonObject.filter(item => item.SerialNumber !== itemToRemove.SerialNumber);
    this.refreshUICalculations();
  }


  loadDataGrid(data: any) {
    
    data.forEach(element => {
      element.Price = element.Price;
      if(element.DiscountAmount > 0)
        element.GrandAmount = (element.Price * element.Quantity) - element.DiscountAmount;
      else
        element.GrandAmount = element.Price * element.Quantity;

      this.jsonObject.push(element);
    });
    this.refreshUICalculations();
  }

  refreshUICalculations() {
    this.jsonObject.forEach((node) => { if (node.ProductCode) { this.applyGridCalculations(node) } });
    this.applyFooterCalculations();
  }

  applyGridCalculations(data: any) {

    if (data.Quantity == 0)
      data.Quantity = 1;

    data.Quantity = this.svf.quantityFormat(data.Quantity);
    data.DiscountAmount = this.svf.quantityFormat(data.DiscountAmount);
    data.GrandAmount = this.svf.amountFormat(((Number(data.Price) * data.Quantity) - data.DiscountAmount)); //price formula for discount
  }

  closeModal() {
    if (this.modalInstance) {
      this.modalInstance.hide();
    }
  }

  openModal(productCode: string) {

    if (this.isBillList || this.isPaidOrderList) {
      this.isBillList = false;
      this.isPaidOrderList = false;
    }

    var isContinue = true;
    // this.selectedUOMs = this.groupedProducts[productCode] || [];
    this.selectedUOMs = (this.groupedProducts[productCode] || []).map(uom => ({
      ...uom,
      Quantity: 1  // Set default quantity to 1
    }));

    if (this.selectedUOMs == null || this.selectedUOMs.length == 0) {

      this.selectedUOMs = this.filteredFamilyDetails.filter(x => x.ProductCode == productCode);
    }

    if (this.selectedUOMs.length == 1) {
      this.addToCart(this.selectedUOMs[0]);
      isContinue = false;
    }

    if (isContinue) {
      const modalElement = document.getElementById('uomModal');
      if (modalElement) {
        this.modalInstance = new bootstrap.Modal(modalElement);
        this.modalInstance.show();
      }
    }
  }

  selectCategory(categoryId: number) {
    const selectedCategory = this.familyCategories.find(cat => cat.ProductGroupCode === categoryId);
    if (selectedCategory) {
      this.selectedCategory = selectedCategory.Name;
      if (selectedCategory.FamilyGroupDetail != null) {
        this.processProducts(selectedCategory.FamilyGroupDetail);
        // this.filteredFamilyDetails = [...selectedCategory.FamilyGroupDetail];
      }
      else
        this.GetProductFamilyDetailList(String(categoryId));
    } else {
      this.filteredFamilyDetails = [];
      this.GetProductFamilyDetailList(String(categoryId));
    }
  }

  selectedPayment: 'cash' | 'card' | null = null;

  holdModels() {
    this.model.Status = 0;
    this.createOrder();
  }

  loadDataInGrid(item: any) {
    var data = [];
    var newRecord = new ResOrderDetails();
    newRecord.SerialNumber = this.jsonObject.length + 1;
    newRecord.ProductName = item.ProductName + "" + item.UOMName;
    newRecord.ProductCode = item.ProductCode;
    newRecord.ProductBarCode = item.ProductBarCode;
    newRecord.Quantity = item.Quantity == undefined ? 1 : item.Quantity;
    newRecord.UnitType = item.UnitType;
    newRecord.UOMName = item.UOMName;
    newRecord.UnitCode = item.UnitCode;
    newRecord.ProductType = item.ProductType;
    newRecord.DiscountAmount = item.DiscountAmoount;
    newRecord.DiscountRate = item.DiscountRate;
    newRecord.Action = 'Save';
    newRecord.Price = item.Price;
    newRecord.GrandAmount = (item.Price * item.Quantity) - Number(item.DiscountAmount);
    newRecord.GrandAmount = 0;
    if (this.isUpdate)
      newRecord.IsUpdated = true;

    data.push(newRecord);
    if (this.jsonObject == undefined)
      this.jsonObject = [];

    this.jsonObject.push(newRecord);
    this.refreshUICalculations();
  }

  selectType(type: string): void {
    this.selectedType = type;
    this.model.Status = 1;

    if (type == 'DineIn') {
      this.model.OrderType = 1;
      this.isDineIn = true;
      this.isTakeAway = false;
      this.isDelivery = false;
      this.model.DeliveryCharges = 0;
    }
    else if (type == 'Take Away') {
      this.model.OrderType = 2;
      this.isDineIn = false;
      this.isTakeAway = true;
      this.isDelivery = false;
      this.model.DeliveryCharges = 0;
    }
    else if (type == 'Delivery') {
      this.model.OrderType = 3;
      this.model.DeliveryCharges = 40;
      this.isDineIn = false;
      this.isTakeAway = false;
      this.isDelivery = true;
    }

    this.refreshUICalculations();
    this.cdr.detectChanges();
    setTimeout(() => {
      if (this.isTakeAway && this.customerNameInput) {
        this.customerNameInput.nativeElement.focus();
      } else if (this.isDelivery && this.customerPhoneInput) {
        this.customerPhoneInput.nativeElement.focus();
      }
    }, 0);
  }

  appendUpdateOrder(data: any) {
    this.isUpdate = true;
    this.isGenerateBill = false;
    this.isBillList = false;
    this.isPaidOrderList = false;
    this.model = new ResOrders();
    this.model = data;
    this.selectedType = this.model.OrderType == 1 ? 'DineIn' : (this.model.OrderType == 2 ? 'Take Away' : 'Delivery');
    var selectedItem = this.globalTaxes.find(x => x.TaxGroupCode == this.model.GlobalTaxCode);
    if (selectedItem) {
      this.model.GlobalTaxGroupName = selectedItem.TaxGroupName;
    }

    this.model.ProductDiscountTotal = data.ResOrderDetailList.reduce((sum, x) => sum + x.DiscountAmount, 0);

    this.jsonObject = [];
    this.selectType(this.selectedType);
    this.loadDataGrid(data.ResOrderDetailList);
  }

  appendBillOrder(data: any) {
    this.isUpdate = false;
    this.isGenerateBill = true;
    this.isBillList = false;
    this.isPaidOrderList = false;
    this.model = new ResOrders();
    this.model = data;
    this.selectPayment('cash');
    this.selectedType = this.model.OrderType == 1 ? 'DineIn' : (this.model.OrderType == 2 ? 'Take Away' : 'Delivery');

    var selectedItem = this.globalTaxes.find(x => x.TaxGroupCode == this.model.GlobalTaxCode);
    if (selectedItem) {
      this.model.GlobalTaxGroupName = selectedItem.TaxGroupName;
    }
    this.model.ProductDiscountTotal = data.ResOrderDetailList.reduce((sum, x) => sum + x.DiscountAmount, 0);
    this.jsonObject = [];
    this.loadDataGrid(data.ResOrderDetailList);
  }

  openNewmodel() {

    this.jsonObject = [];
    this.model = new ResOrders();
    this.model.OrderCode = '';
    this.model.DeliveryCharges = 0;
    this.model.CustomerName = '';
    this.model.Phone = '';
    this.model.Address = '';
    this.model.Status = 1;
    this.model.OrderType = 1;
    this.selectedPayment = 'cash';
    this.isDineIn = true;
    this.isTakeAway = false;
    this.isDelivery = false;
    this.selectedType = "DineIn";
    this.isUpdate = false;
    this.isBillList = false;
    this.isPaidOrderList = false;
    this.isGenerateBill = false;
    this.model.ProductDiscountTotal = 0;
    var cashMethod = this.globalTaxes.find(x => x.Tax1Name == "Cash");
    if(cashMethod){
      this.model.GlobalTaxCode = cashMethod.Tax1Code;
      this.model.GlobalTaxRate = cashMethod.Tax1Value;
      this.model.GlobalTaxGroupName = cashMethod.Tax1Name;
    }
    
    this.selectType(this.selectedType);
  }


  applyFooterCalculations() {
    
    this.model.GrandAmount = 0;
    this.model.NetAmount = 0;
    this.model.ProductDiscountTotal = 0;
    this.jsonObject.forEach((node) => {
      if (node.ProductCode) {
        this.model.GrandAmount += Number(node.GrandAmount);
        this.model.NetAmount += Number(node.GrandAmount);
        if(Number(node.DiscountAmount) > 0)
          this.model.ProductDiscountTotal += Number(node.DiscountAmount);
      }
    });

    this.model.GrandAmount = this.svf.amountFormat(this.model.GrandAmount);

    if (this.model.GlobalDiscountRate != 0 && this.model.GlobalDiscountRate != undefined) {
      if (this.model.GlobalDiscountRate > 100) {
        this.model.GlobalDiscountRate = 100;
      }
      this.model.GlobalDiscountAmount = ((this.model.GrandAmount * this.model.GlobalDiscountRate) / 100);
      this.model.GlobalDiscountAmount = this.svf.amountFormat(this.model.GlobalDiscountAmount);
    }

    this.model.GlobalDiscountAmount = this.svf.amountFormat(this.model.GlobalDiscountAmount);
    if (this.selectedType == 'Delivery')
      this.model.NetAmount = this.model.GrandAmount + Number(this.model.DeliveryCharges) - this.model.GlobalDiscountAmount;
    else
      this.model.NetAmount = this.model.GrandAmount - this.model.GlobalDiscountAmount;

    //Tax calculation
    if (this.model.GlobalTaxGroupName != '' && this.model.GlobalTaxGroupName != undefined) {
      this.model.GlobalTaxAmount = ((this.model.NetAmount * this.model.GlobalTaxRate) / 100);
      this.model.GlobalTaxAmount = this.svf.amountFormat(this.model.GlobalTaxAmount);
      this.model.NetAmount = this.model.NetAmount + this.model.GlobalTaxAmount;
    }

    this.model.NetAmount = this.svf.amountFormat(this.model.NetAmount);
  }

  createOrder() {
    var isContinue = true;
    if (!this.model.OrderType) {
      this.toastrService.error(this.translate.transform('3969'));
      isContinue = false;
      return;
    }

    if (this.jsonObject.length == 0) {
      this.toastrService.error(this.translate.transform('1487'));
      isContinue = false;
      return;
    }

    this.model.ResOrderDetailList = [];

    this.jsonObject.forEach(element => {
      if (element.ProductCode) {
        element.Price = element.Price;
        this.model.ResOrderDetailList.push(element);
      }
    });

    if (isContinue) {
      var reportModel = new ResOrders();
      reportModel = this.model;
      if (!this.isUpdate)
        this.model.IsInserting = true;
      else
        this.model.IsInserting = false;

      if (this.isUpdate && this.model.Status == 0)
        this.model.Status = 1;

      if (!this.model.PaymentMode) {
           this.model.PaymentMode = '1'
      }

      if(this.SalesAgentData)
        this.model.RestaurantSalesAgentCode = this.SalesAgentData[0].code;

      if(this.selectedType != 'Delivery'){
         this.model.DeliveryCharges = 0 ;
      }

      console.log(this.model.ResOrderDetailList, "Model Print");
      this.restaurantService.ordersRepository.SaveOrder(this.model).subscribe((data: any) => {
        this.loaderService.setIgnoreLoader(false);
        if (data && data._statusCode == 200) {
          $('#OrderModalForm').modal('hide');
          if (this.model.Status == 0)
            this.toastrService.success(this.translate.transform('3978'));
          else
            this.toastrService.success(this.translate.transform(data._message));

          if (this.isUpdate) {
            this.printModel = this.model;
            var printerName = this.model.ResOrderDetailList[0].PrinterName;
            this.printModel.ResOrderDetailList = this.model.ResOrderDetailList.filter(x => x.IsUpdated == true);
            setTimeout(() => {
              // this.printModel = data._obj;
              this.printModel.CompanyName = this.companyname;
              this.printModel.NTN = this.ntn;
              this.printModel.CompanyAddress = this.CompanyAddress;
              this.printModel.PhoneNumber = this.companyMobile;
              this.printModel.FaxNumber = this.companyFax;
              this.printModel.GlobalDiscountRate = Number(this.printModel.GlobalDiscountRate);



              const printerSet = new Set<string>();
              console.log(this.printModel, "Update model");
              this.printModel.ResOrderDetailList.forEach(element => {

                if (element.PrinterName) {

                  const printers = element.PrinterName.split(',')
                    .map(p => p.trim())
                    .filter(p => p); // remove empty strings
                  printers.forEach(p => printerSet.add(p)); // avoid duplicates
                }

              });

              if (printerSet.size == 0) {
                printerSet.add(printerName);
              }
              console.log(printerSet, "Printer set");
              printerSet.forEach(element => {
                if (element) {
                  this.printModel.PrinterName = element;
                  this.socketService.sendMessage(JSON.stringify(this.printModel));
                }
              });
              this.openNewmodel();

            }, 500); // delay is safe now
          }
          else {
            this.openNewmodel();
          }
        }
        else {
          this.toastrService.error(this.translate.transform(data._message));
        }
        // this.loaderService.display(false);
      });
    }
    // this.loaderService.display(false);
  }

  createBill() {
    // this.isLoading = true;
    var isContinue = true;

    this.model.GoDownCode = this.godownData[0].code;
    this.model.ResOrderDetailList = [];
    this.model.IsPaid = true;
    if (this.model.OrderType != 2)
      this.model.Status = 3;

    if (!this.model.PaymentMode) {
      this.toastrService.error('Payment is required.');
      isContinue = false;
      return;
    }

    this.jsonObject.forEach(element => {
      if (element.ProductCode) {
        element.Price = element.Price;
        this.model.ResOrderDetailList.push(element);
      }
    });

    if (isContinue) {
      this.restaurantService.ordersRepository.SaveBill(this.model).subscribe((data: any) => {
        this.loaderService.setIgnoreLoader(false);
        if (data && data._statusCode == 200) {

          $('#BillModalForm').modal('hide');
          setTimeout(() => {

            this.printModel = this.model;
            this.printModel.CompanyName = this.companyname;
            this.printModel.NTN = this.ntn;
            this.printModel.CompanyAddress = this.CompanyAddress;
            this.printModel.PhoneNumber = this.companyMobile;
            this.printModel.FaxNumber = this.companyFax;
            const printerSet = new Set<string>();

            this.model.ResOrderDetailList.forEach(element => {

              if (element.PrinterName) {
                const printers = element.PrinterName.split(',')
                  .map(p => p.trim())
                  .filter(p => p); // remove empty strings

                printers.forEach(p => printerSet.add(p)); // avoid duplicates
              }
            });

            printerSet.forEach(element => {
              if (element) {
                this.printModel.PrinterName = element;
                this.socketService.sendMessage(JSON.stringify(this.printModel));
              }
            });
            this.openNewmodel();

          }, 500); // delay is safe now
          var isContinue = false;
          this.toastrService.success(this.translate.transform(data._message));
        }
        else {
          var isContinue = false;
          this.toastrService.error(this.translate.transform(data._message));
        }
        // this.isLoading = false;
      });
    }
    // this.isLoading = false;
  }

  printReport(order: any) {
    this.model = order;
    this.totalSum = this.model.ResOrderDetailList.reduce((sum, item) => {
      return sum + (item.Price * item.Quantity);
    }, 0);
    this.printTime = formatDate(new Date(), 'dd-MM-yyyy hh:mm:ss a', 'en-US');
    this.model.PrinterName = this.printerName;
    this.model.CompanyName = this.companyname;
    this.model.NTN = this.ntn;
    this.model.CompanyAddress = this.CompanyAddress;
    this.model.PhoneNumber = this.companyMobile;
    this.model.FaxNumber = this.companyFax;

    const printerSet = new Set<string>();

    this.model.ResOrderDetailList.forEach(element => {

      if (element.PrinterName) {
        const printers = element.PrinterName.split(',')
          .map(p => p.trim())
          .filter(p => p); // remove empty strings

        printers.forEach(p => printerSet.add(p)); // avoid duplicates
      }
    });

    printerSet.forEach(element => {
      if (element) {
        this.model.PrinterName = element;
        this.socketService.sendMessage(JSON.stringify(this.model));
      }
    });

  }

  orderCountDown() {
    if (this.pendingOrdersList && this.pendingOrdersList.length) {
      const now = new Date().getTime();
      this.pendingOrdersList.forEach(order => {
        const orderCreatedTime = new Date(order.OrderRecordTimeStamp).getTime();

        let diff = now - orderCreatedTime; // elapsed time in ms

        if (diff < 0) {
          // If OrderDateTime is in the future, reset to zero
          diff = 0;
        }

        order.Hour = Math.floor(diff / (1000 * 60 * 60));
        order.Minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        order.Seconds = Math.floor((diff % (1000 * 60)) / 1000);
      });
    }
  }

  getOrderTotal(orderDetails: any[], globalDiscount: number = 0, globalTaxAmount: number = 0): number {
    const total = orderDetails.reduce((sum, item) => {
      return sum + (item.Price * item.Quantity + globalTaxAmount);
    }, 0);

    return total - globalDiscount;
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    if (this.subscription)
      this.subscription.unsubscribe();

    if (this.intervalSubscription)
      this.intervalSubscription.unsubscribe();
    sessionStorage.removeItem(this.commonconstant.Kitchen_Notifications_List)
  }

  showNotification(order: ResOrders, Operation: string = 'INSERT') {

    let orderMsg = this.translate.transform('505') + ': #' + order.OrderCode + '<br/> ' + this.translate.transform('3632') + ': ' + order.TimeRequired;
    this.toastrService.info(orderMsg,
      Operation === 'INSERT' ? this.translate.transform('3692') : this.translate.transform('3693'),
      {
        timeOut: 1000,
        positionClass: 'toast-bottom-right',
        toastClass: 'custom-Toast'
      }
    );

    let newNotification = new Notification();

    newNotification.OrderCode = order.OrderCode;
    newNotification.TimeRequired = order.TimeRequired;
    newNotification.IsInsertNotification = Operation == "INSERT";
    newNotification.RowIndex = this.notifications.length;
    this.notifications.push(newNotification)

    // Delay added so that div load in view
    setTimeout(() => {

      $("#" + newNotification.OrderCode).addClass("hvr-buzz");
      setTimeout(() => {

        $("#" + newNotification.OrderCode).removeClass("hvr-buzz");
      }, 1500)
    }, 200);

    this.totalUnreadNotifications = this.notifications.filter(x => !x.IsNotificationRead).length;
    this.updateNotificationsInStorage()

  }

  private updateNotificationsInStorage() {
    sessionStorage.removeItem(this.commonconstant.Kitchen_Notifications_List)
    sessionStorage.setItem(this.commonconstant.Kitchen_Notifications_List, this.notifications && this.notifications.length > 0 ? JSON.stringify(this.notifications) : null)
  }

  private updateNotificationsListFromStorage() {
    let obj = sessionStorage.getItem(this.commonconstant.Kitchen_Notifications_List)
    if (obj) {
      this.notifications = JSON.parse(obj)
      this.totalUnreadNotifications = this.notifications.filter(x => !x.IsNotificationRead).length;
    }
  }

  onNotificationClick(clickedNotification: Notification) {

    clickedNotification.IsNotificationRead = true;
    this.totalUnreadNotifications = this.notifications.filter(x => !x.IsNotificationRead).length;

    document.getElementById(clickedNotification.OrderCode).scrollIntoView({ behavior: "smooth" });

    $("#" + clickedNotification.OrderCode).addClass("hvr-buzz");

    setTimeout(() => {
      $("#" + clickedNotification.OrderCode).removeClass("hvr-buzz");
    }, 1500)

    setTimeout(() => {
      $("html, body").animate({ scrollTop: 0 });
    }, 1500);
    this.updateNotificationsInStorage()
  }

  onReadAllNotificationClick() {
    this.notifications.forEach(element => {
      element.IsNotificationRead = true;
    });
    this.updateNotificationsInStorage()
    this.totalUnreadNotifications = 0;
  }


  sortNotifications() {
    return sortArray(this.notifications, 'RowIndex').reverse();
  }

  onGlobalTaxChange(value) {
    if (this.globalTaxes) {
      var selectedItem = this.globalTaxes.find(x => x.TaxGroupCode == value);
      if (selectedItem == null || selectedItem == undefined)
        selectedItem = this.globalTaxes.find(x => x.TaxGroupName.toLowerCase() == value.toLowerCase());
      if (selectedItem) {
        this.model.GlobalTaxGroupName = selectedItem.TaxGroupName;
        this.model.GlobalTaxGroupID = selectedItem.TaxGroupCode;
        this.model.GlobalTaxCode = selectedItem.TaxGroupCode;
        this.model.GlobalTaxRate = selectedItem.Tax1Value;
      }
      else {
        this.model.GlobalTaxGroupName = "";
        this.model.GlobalTaxGroupID = "";
        this.model.GlobalTaxAmount = 0;
        this.model.GlobalTaxCode = "";
        this.model.GlobalTaxRate = 0;
      }

      this.applyFooterCalculations();
    }
  }
}

export class Notification {
  constructor() {
    this.IsNotificationRead = false;
  }
  RowIndex: number;
  OrderCode: string;
  TimeRequired: number;
  IsNotificationRead: boolean;
  IsInsertNotification: boolean;
}
